import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const organisationRecordHiringTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "organisation.record.hiring-trend",
  name: "New employments",
  description: "New employments across the selected period.",
  apps: [
    "configuration",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "hr.employments",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "employment_id",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Employments started",
        query: {
          version: 1,
          source: "hr.employments",
          ...period(30),
          select: [
            {
              type: "field",
              field: "start_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "count_distinct",
              field: "employment_id",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "start_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#2fb344",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "New employments",
    valueFormat: "number",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "0",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
